/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Task status enumeration
 */
export enum TaskStatus {
    SCHEDULED = 'scheduled',
    OVERDUE = 'overdue',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
}
